import { useState } from "react";
import { Input, Form, Modal, Typography } from "antd";

import { setEmailForNotifications } from "@/api/users";

const { Text } = Typography;

// Окно для смены пароля
const ChangeEmailModal = ({ data = {}, visible, onSave, onCancel }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      await setEmailForNotifications({
        uuid: data.uuid,
        secondary_email: values.secondary_email || "",
      });

      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  return (
    <Modal
      maskClosable={false}
      title="Email для уведомлений"
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText="Сохранить"
      cancelText="Отменить"
      okButtonProps={{ loading: isLoading }}
      width={350}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        onFinish={handleSave}
      >
        <Form.Item name="secondary_email">
          <Input placeholder="Введите email" />
        </Form.Item>

        {error && (
          <div>
            <Text type="danger">{error}</Text>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default ChangeEmailModal;
